import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ShareArrow = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: size || "24",
    height: size || "24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.221 5.361l4.453 4.722-4.453 4.723v-1.7l-.758-.19a9.37 9.37 0 0 0-2.274-.283c-2.936 0-5.684 1.228-7.673 3.211 2.179-8.31 8.905-8.783 9.758-8.783h.947v-1.7zm-.947.756C12.189 6.21 3.664 7.627 3 20c1.516-3.778 5.116-6.328 9.19-6.328.663 0 1.326.095 2.084.19v3.305L21 10.083 14.274 3v3.117z"
  }));
};
ShareArrow.displayName = 'ShareArrow';
export default ShareArrow;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ShareArrow.js.map